jQuery(document).ready(function () {
    if (window.matchMedia("(min-width: 1023px)").matches) {
        var triotextLeftHeight = $(".triotext_left").outerHeight();
        var triotextRightHeight = $(".triotext_right").outerHeight();
        
        if (triotextRightHeight < triotextLeftHeight) {
          $(".triotext_right").css("height", triotextLeftHeight + "px");
        }
      }
});
